import React from 'react';
import { ChevronDown } from 'react-bootstrap-icons';

interface TransferItemFormStructureProps {
    inputFields: React.ReactNode[];
}

const TransferItemFormStructure: React.FC<TransferItemFormStructureProps> = ({ inputFields }) => {
    return (
        <>
            <div className="my-2 bg-white rounded py-1 px-2 ">
                <div className="my-2 bg-white rounded py-1 px-2 d-flex justify-content-end">
                    <div className="align-self-center">
                        <span
                            className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"

                        >
                            <ChevronDown />
                        </span>
                    </div>

                </div>
                <div className="checkin-details col-12 bg-white col-12 py-2 px-5 ">
                    <div className="row">
                        {inputFields.map((field, index) => (
                            <div key={index} className="col-lg-2 col-md-2 col-sm-6">
                                {field}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TransferItemFormStructure;
